import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import RegularButton from "../../components/CustomButtons/Button";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    minWidth: "600px",
    padding: theme.spacing(1),
  },
  dialogPaper: {
    minWidth: "600px",
  },
}));

export default function LabSolutionFormDialog({
  open,
  onClose,
  onSubmit,
  editData,
}) {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: "",
    prompt: "",
    prompt_description: "",
    rank: 0,
    category: "",
  });
  const [rankError, setRankError] = useState("");

  useEffect(() => {
    if (editData) {
      setFormData(editData);
    }
  }, [editData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "rank" ? Number(value) : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (formData.rank <= 0) {
      setRankError("Rank must be greater than 0");
      return;
    }
    onSubmit(formData);
    handleClose();
  };

  const handleClose = () => {
    setFormData({
      name: "",
      prompt: "",
      prompt_description: "",
      rank: 0,
      category: "",
    });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
      fullWidth
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <DialogTitle id="form-dialog-title">
        {editData ? "Edit LAB Solution" : "Add New LAB Solution"}
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <div className={classes.form}>
            <TextField
              required
              name="name"
              label="Name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
            <FormControl required fullWidth>
              <InputLabel>Category</InputLabel>
              <Select
                name="category"
                value={formData.category}
                onChange={handleChange}
                label="Category"
              >
                <MenuItem value="IOS Design">IOS Design</MenuItem>
                <MenuItem value="IOS Analysis">IOS Analysis</MenuItem>
              </Select>
            </FormControl>
            <TextField
              required
              name="prompt"
              label="Prompt"
              value={formData.prompt}
              onChange={handleChange}
              multiline
              minRows={4}
              fullWidth
            />
            <TextField
              required
              name="prompt_description"
              label="Prompt Description"
              value={formData.prompt_description}
              onChange={handleChange}
              multiline
              minRows={3}
              fullWidth
            />
            <TextField
              required
              type="number"
              name="rank"
              label="Rank"
              value={formData.rank}
              onChange={handleChange}
              error={!!rankError}
              helperText={rankError}
              inputProps={{ min: 1 }}
              fullWidth
            />
          </div>
        </DialogContent>
        <DialogActions>
          <RegularButton size="sm" onClick={handleClose} color="tumblr">
            Cancel
          </RegularButton>
          <RegularButton size="sm" type="submit" color="info">
            Save
          </RegularButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}
